import { motion } from 'framer-motion';
import Collections from '../pages/Collections';

const FeaturedCollections = () => {
  const categories = [
    { title: "Bridal Sets", image: "https://blingitup.store/wp-content/uploads/2025/06/best-bridal-jewellery-set-in-erode-1370x550.jpg", gridSpan: "md:col-span-2 md:row-span-2" },
    { title: "Daily Wear Rings", image: "https://rubans.in/cdn/shop/files/rubans-voguish-18k-gold-plated-textured-ribbon-statement-adjustable-ring-finger-ring-1120145519.jpg?v=1770709799&width=360", gridSpan: "col-span-1" },
    { title: "Gold Coins", image: "https://sukkhi.com/cdn/shop/products/SKR108646.jpg?v=1661428298&width=1500", gridSpan: "col-span-1" },
    { title: "Luxury bracelets", image: "https://down-my.img.susercontent.com/file/sg-11134201-7rd5y-lvj9ol0dg6s43e", gridSpan: "md:col-span-2" },
  ];

  return (
    <section className="py-16 px-4 bg-[#fdfaf5]">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-serif text-[#4a2c2a] text-center mb-12">
          Discover Our Jewellwers
          <span className="block w-20 h-1 bg-[#b8860b] mx-auto mt-2"></span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[200px]">
          {categories.map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.02 }}
              className={`relative overflow-hidden group rounded-lg cursor-pointer ${item.gridSpan}`}
            >
              <img 
                src={item.image} 
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex items-end p-6">
                <div>
                  <h3 className="text-white text-xl font-medium">{item.title}</h3>
                  {/* <p className="text-gold-400 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Explore More →
                  </p> */}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default FeaturedCollections; // Ye line file ke end mein honi chahiye